import { css, SerializedStyles, Theme } from "@emotion/react";

export const emptyStateWrapper = css`
  position: relative;
  height: 16.25rem;
`;

export const emptyStateContainer = css`
  position: absolute;
  top: 3rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const emptyStateIcon = ({ icon }: Theme): SerializedStyles => css`
  display: flex;
  justify-content: center;
  color: ${icon.primary};
`;

export const emptyStateBody = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const emptyStateDescription = ({ widgets }: Theme): SerializedStyles => css`
  color: ${widgets.descriptionColor};
`;

export const emptyStateFooter = css`
  margin-top: 1rem;
`;
